import { render } from "./Logo.vue?vue&type=template&id=a871b5c6"
const script = {}

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__